import React from 'react';
import './App.css';
import { Routes, Route } from 'react-router-dom';
import Layout from './components/Layout';
import Portfolio from './components/Portfolio';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import About from './pages/About';
import AdminLogin from './pages/AdminLogin';
import AdminDashboard from './pages/AdminDashboard';
import BlogEditor from './pages/BlogEditor';

function App() {
  return (
    <Layout>
      <div className="min-h-screen relative pb-16">
        <Routes>
          <Route path="/" element={<Portfolio />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/about" element={<About />} />
          <Route path="/admin" element={<AdminLogin />} />
          <Route path="/admin/dashboard" element={<AdminDashboard />} />
          <Route path="/admin/create" element={<BlogEditor />} />
          <Route path="/admin/edit/:id" element={<BlogEditor />} />
        </Routes>
        <footer className="absolute bottom-0 w-full backdrop-blur-md bg-black/30 dark:bg-black/50 border-t border-white/5">
          <div className="py-2 px-4 flex justify-between items-center text-sm text-white/70">
            <span>Designed & developed by Mudit Dubey. All rights reserved.</span>
            <a 
              href="/admin" 
              className="opacity-30 hover:opacity-100 transition-opacity duration-200"
              title="Admin"
            >
              ⚙️
            </a>
          </div>
        </footer>
      </div>
    </Layout>
  );
}

export default App;
